import { EDPColloquial } from '../edp/colloquials';

export abstract class Colloquial {
  static findByCountryAndLanguage<T extends Colloquial = Colloquial>(
    colloquials: T[],
    queriedCountry: string,
    queriedLanguage: string
  ): T {
    return colloquials.find(
      ({ countryCodeDesc, languageDesc }: T) => countryCodeDesc === queriedCountry && languageDesc === queriedLanguage
    );
  }

  protected constructor(
    public id: number,
    public countryCodeDesc: string,
    public languageDesc: string
  ) {}

  abstract toEDPColloquial(): EDPColloquial;
}
